import { render, staticRenderFns } from "./GeneticFitInfoModal.vue?vue&type=template&id=39e44090&scoped=true"
import script from "./GeneticFitInfoModal.vue?vue&type=script&lang=js"
export * from "./GeneticFitInfoModal.vue?vue&type=script&lang=js"
import style0 from "./GeneticFitInfoModal.vue?vue&type=style&index=0&id=39e44090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e44090",
  null
  
)

export default component.exports